import { char, number } from "../../../../utils";
import { selector } from "../../../../api";
import moment from "moment";
import { Loader } from "rsuite";

export const CollectionCenterIncome = (props) => {
  const { data, loading, dataRef, tableRef } = props;

  const user = selector.User();

  return (
    <>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "50vh", // Full viewport height
            overflow: "hidden",
          }}
        >
          <Loader
            backdrop
            size="md"
            speed="slow"
            content="Please wait..."
            vertical
          />
        </div>
      ) : (
        <>
          <div className="row">
            <div className="col-12">
              <p className="h4">
                Total Collection :{" "}
                <span className="ms-3 h3">
                  {number.fNumberDoublePoint(data?.overall_total_income)}
                </span>
              </p>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-12" ref={dataRef}>
              <div className="printHead">
                <p className="text-center">
                  <img
                    width={100}
                    className="mt-0 mb-2"
                    src="assets/images/suza.jpeg"
                    alt=""
                  />
                </p>
                <p className="text-center fw-bold head1">
                  {char.toTitleCase("state university of Zanzibar")}
                </p>
                <p className="text-center mt-3 mb-3 head2">
                  {char.toUpperCase("center collection report")}
                </p>
                <p className="text-end">
                  Printed By :{" "}
                  <span className="fw-bold">
                    {char.toUpperCase(user.username)}
                  </span>
                </p>
                <p className="text-end mb-2">
                  Printed at :{" "}
                  <span className="fw-bold">
                    {moment().format("ddd DD MMM YYYY")}
                  </span>
                </p>
              </div>
              <div className="table-responsive" ref={tableRef}>
                <table className="table table-bordered table-sm">
                  <thead className="table-head">
                    <tr>
                      <th style={{ width: 50 }}>#</th>
                      <th>Center Name</th>
                      <th className="text-end">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.accounts_income?.map((dt, i) => (
                      <tr>
                        <td>{i + 1}</td>
                        <td>
                          {dt.name
                            ? char.toUpperCase(char.processParagraph(dt.name))
                            : "N/A"}
                        </td>
                        <td className="text-end">
                          {number.fNumberDoublePoint(dt.total_income)}
                        </td>
                      </tr>
                    ))}
                    {!data?.accounts_income?.length && (
                      <tr>
                        <td colSpan={8} className="text-center">
                          {char.toLowerCase("no data to print")}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
